import { rankingItems } from '@/mocks/homeData';

const changeIcon: Record<string, string> = {
  up: 'ri-arrow-up-line text-primary-500',
  down: 'ri-arrow-down-line text-foreground-400',
  new: 'ri-flashlight-line text-accent-500',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              热度榜单
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600">
              全网网红话题实时热度排行，吃瓜必看
            </p>
          </div>

          <div className="bg-background-100 rounded-lg border border-background-200/70 overflow-hidden">
            {rankingItems.map((item, i) => (
              <div
                key={item.rank}
                className={`flex items-center gap-4 px-5 md:px-6 py-4 ${
                  i < rankingItems.length - 1 ? 'border-b border-background-200/70' : ''
                } hover:bg-background-50 transition-colors cursor-pointer group`}
              >
                <div className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-bold flex-shrink-0 ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}>
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <p className="text-sm md:text-base text-foreground-800 group-hover:text-primary-600 transition-colors font-medium">
                    {item.title}
                  </p>
                </div>

                <span className="text-xs md:text-sm text-accent-600 font-semibold whitespace-nowrap flex-shrink-0">
                  {item.hot}
                </span>

                <span className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className={`text-base ${changeIcon[item.change] || changeIcon.up}`}></i>
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}